import { withoutTrailingSlash } from './utils'

export const DASHBOARD_API_DEFAULT_URL = 'http://localhost:4000/api'

export const resolveDashboardApiUrl = () =>
  withoutTrailingSlash(process.env.NEXT_PUBLIC_DASHBOARD_API_URL ?? DASHBOARD_API_DEFAULT_URL) ??
  DASHBOARD_API_DEFAULT_URL
